import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
  "What do you need built?",
  "Do you have a website already?",
  "What should it help you do?",
  "Anything else we should know?",
  "How can we reach you?",
];

export default function IntakeTeaser() {
  return (
    <section
      data-testid="intake-teaser-section"
      className="relative border-t border-white/10 px-5 py-24 md:px-16 md:py-40"
    >
      <div className="mx-auto grid max-w-[1500px] gap-14 md:grid-cols-2 md:gap-20">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.9, ease: EASE }}
            className="mb-6 text-[10px] font-medium uppercase tracking-[0.5em] text-fog md:text-xs"
          >
            Have an idea or a problem to solve?
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1, ease: EASE }}
            className="font-display text-4xl font-semibold leading-[0.98] tracking-[-0.03em] md:text-6xl"
          >
            TELL US WHAT<br />YOU&rsquo;RE<br />WORKING ON.
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="flex flex-col justify-between border border-white/15 p-6 md:p-10"
        >
          <div>
            <p className="text-sm leading-relaxed text-fog md:text-base">
              Answer a few quick questions about your business and what you&rsquo;d like to
              improve. You don&rsquo;t need to have it all figured out.
            </p>
            <ul className="mt-8">
              {STEPS.map((s, i) => (
                <li
                  key={s}
                  className="flex items-baseline gap-5 border-t border-white/10 py-3.5 last:border-b"
                >
                  <span className="text-[10px] tracking-[0.3em] text-fog/70">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-sm text-fog md:text-base">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-10 flex justify-end">
            <Link
              to="/start"
              data-testid="teaser-start-link"
              className="group flex items-center gap-2 border border-white px-5 py-3 text-xs font-semibold uppercase tracking-[0.25em] transition-colors duration-500 ease-cinematic hover:bg-white hover:text-obsidian"
            >
              Start a Project
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-500 ease-cinematic group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
